import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Goal as GoalModel } from '@feathr/blackbox';
import { CurrencyEntry } from '@feathr/components';

import { shouldRender } from './ConversionValueEntry.utils';

interface IProps {
  goal: GoalModel;
}

function ConversionValueEntry({ goal }: Readonly<IProps>): JSX.Element | null {
  const { t } = useTranslation();

  if (!shouldRender({ goal })) {
    return null;
  }

  function handleChangeValue(value: number): void {
    goal.set({ conv_value: value });
  }

  return (
    <CurrencyEntry
      description={t('Enter the monetary value of this goal. ')}
      label={t('Conversion value')}
      onChange={handleChangeValue}
      value={goal.get('conv_value') as number}
    />
  );
}

export default observer(ConversionValueEntry);
